export default "__VITE_ASSET__BIVzGm7B__"